import titleize from './titleize'

const regex: RegExp = /-/g

function slugToTitle(slug: string): string {
  // Remove the leading slash.
  slug = slug.replace(/^\//, '')

  // Split the slug into words.
  const words = slug.split(regex)

  // Capitalize the first letter of each word.
  words.forEach((word) => {
    word = word.charAt(0).toUpperCase() + word.substring(1)
  })

  // Join the words back together with spaces.
  const title = words.join(' ')

  return titleize(title)
}

export default slugToTitle
